var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "uni-collapse" },
    [
      _c(
        "el-collapse",
        {
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-collapse-item",
            { staticClass: "uni-collapse-item", attrs: { name: _vm.name } },
            [
              _c("template", { slot: "title" }, [
                _c("div", { staticClass: "header" }, [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c("i", { staticClass: "el-icon-arrow-up" }),
                      _c("i", { staticClass: "iconfont icon123 gray-light" }),
                      _c("span", { staticClass: "cell-title" }, [
                        _vm._v(_vm._s(_vm.title)),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "refresh-box" },
                    [
                      _vm._t("title-right", function () {
                        return [
                          _vm.datas.length == 0
                            ? [
                                _c("i", {
                                  staticClass:
                                    "iconfont iconV_heziguanli-dengdaigengxin",
                                }),
                                _c("span", [_vm._v("待更新")]),
                              ]
                            : _vm._e(),
                        ]
                      }),
                    ],
                    2
                  ),
                ]),
              ]),
              _vm._t("collapseContent", function () {
                return _vm._l(_vm.datas, function (item) {
                  return _c(
                    "div",
                    { key: item.studentUuid, staticClass: "collapse-cell" },
                    [
                      _c(
                        "div",
                        { staticClass: "title-box item" },
                        [
                          item.isFinish
                            ? _c("i", {
                                staticClass: "iconfont icongouxuan primary",
                              })
                            : _c("el-progress", {
                                staticStyle: { "vertical-align": "middle" },
                                attrs: {
                                  width: 40,
                                  strokeWidth: 2,
                                  color: "#2E58FF",
                                  type: "circle",
                                  percentage: item.studyProgress || 0,
                                },
                              }),
                          _c("span", { staticClass: "span tit" }, [
                            _vm._v(_vm._s(item.title)),
                          ]),
                          item.videoid
                            ? _c("span", { staticClass: "span" }, [
                                _vm._v(
                                  _vm._s(_vm._f("formatSeconds")(item.duration))
                                ),
                              ])
                            : _c("span", { staticClass: "span" }, [
                                _vm._v("暂无课程视频"),
                              ]),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "item" }, [
                        _c(
                          "span",
                          {
                            class: _vm.getCourseClass(item.studyProgress).style,
                            staticStyle: { "margin-left": "100px" },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.getCourseClass(item.studyProgress).txt)
                            ),
                          ]
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "item" },
                        [
                          item.workTotal > 0
                            ? [
                                _c("span", { staticClass: "span" }, [
                                  item.workFinish
                                    ? _c("i", {
                                        staticClass:
                                          "iconfont icongouxuan primary",
                                      })
                                    : _c("i", {
                                        staticClass:
                                          "iconfont iconjinzhi-yin gray-light",
                                      }),
                                  _vm._v(" 作业练习 "),
                                ]),
                                item.isJobComplete
                                  ? _c("span", { staticClass: "oringe" }, [
                                      _vm._v("* 必须完成"),
                                    ])
                                  : _vm._e(),
                              ]
                            : _c("div", [_vm._v("无作业练习")]),
                        ],
                        2
                      ),
                      _c("div", [
                        _c(
                          "span",
                          { staticClass: "span" },
                          [
                            item.videoid
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "uni-link-btn",
                                    attrs: {
                                      type: "primary",
                                      icon: "el-icon-video-play",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.jump("studyNotes", item)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        item.studyProgress
                                          ? "继续学习"
                                          : "开始学习"
                                      )
                                    ),
                                  ]
                                )
                              : _c(
                                  "el-button",
                                  {
                                    staticClass: "uni-disabled-btn",
                                    attrs: {
                                      type: "info",
                                      icon: "el-icon-video-play",
                                      disabled: "",
                                    },
                                  },
                                  [_vm._v("开始学习")]
                                ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  )
                })
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c("ComponentDialog1", {
        attrs: {
          icon: "fail",
          title: _vm.dialogTitle,
          visible: _vm.isDialogVisible,
          showCancelBtn: false,
          confirmText: "确定",
        },
        on: {
          "update:visible": function ($event) {
            _vm.isDialogVisible = $event
          },
          confirm: function ($event) {
            _vm.isDialogVisible = !_vm.isDialogVisible
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }